module.exports = __webpack_public_path__ + "static/media/Water-Usage.cd266540.jpg";